import {
  Box,
  Flex,
  styled,
  $error,
  $fontSize
} from "@acko-tech/building-blocks.ui.common";
import { H5, Text } from "@acko-tech/building-blocks.ui.typography";
import Button from "@acko-tech/building-blocks.ui.button-old";

export const RootContainer = styled(Box)`
  max-width: 372px;
  margin-bottom: 10rem;
`;
export const duration = 200;

export const StyledBox = styled(Box)``;

export const Heading = styled(H5)`
  margin-bottom: 36px;
  margin-top: 10px;
`;

// export const OptionsHeading = styled(Text)`
//   font-weight: ${$fontWeightBold};
//   color: ${$neutralColors.normal};
//   font-size: ${$fontSize.xs};
//   margin-top: 1em;
//   margin-bottom: 21px;
// `;

export const StyledButton = styled(Button)`
  margin-top: 1em;
  max-width: 200px;
`;

export const AnimateWrapper = styled(Box)`
  transform-origin: top;
  poistion: relative;

  &.dropdown-transition-enter {
    opacity: 0;
    transition: none;
  }
  &.dropdown-transition-enter-active {
    opacity: 1;
    transition: opacity ${duration}ms;
  }

  &.dropdown-transition-exit {
    opacity: 1;
  }
  &.dropdown-transition-exit-active {
    opacity: 0;
    transition: opacity ${duration}ms;
  }
`;

export const ErrorText = styled(Text)`
  font-size: 11px;
  color: ${$error};
  white-space: pre-wrap;
  margin-bottom: 1em;
`;

export const FuelOptionsText = styled.p`
  width: 100%;
  margin: 0;
  font-size: ${$fontSize.xs};
  line-height: 17px;
`;

export const FuelTextContainer = styled(Box)`
  padding: 1rem 0;
  width: 85%;
  cursor: pointer;
  :first-child {
    padding-top: 0;
  }
  :last-child {
    padding-bottom: 0;
  }
  :not(:last-child) {
    border-bottom: 1px solid #f4f5f7;
  }
`;

export const Modal = styled(Flex)`
  padding: 2rem 3rem;
  position: absolute;
  max-width: 472px;
  max-height: 418px;
  height: fit-content;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px 4px 35px rgba(8, 12, 41, 0.1);
  border-radius: 12px;
`;
